// @flow
if (typeof window !== `undefined`) {
  const WebFont = require('webfontloader') // eslint-disable-line global-require
  WebFont.load({
    google: {
      families: ['Lato:300,400,900'],
    },
  })
}

module.exports = {
  colors: {
    primary: '#1dacb8',
    primaryLight: '#42B6F7',
    primaryDark: '#19949e',
    secondary: '#ffc605',
    secondaryLight: '#5B6A73',
    secondaryDark: '#d1a100',
  },
  fonts: {
    fontFamily:
      '"Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    monoSpaceFontFamily:
      '"SF Mono", Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace',
  },
}



// WEBPACK FOOTER //
// ./src/style/styleConfig.js